export default "/moocrvUSD-USDC.ed9db9c478eef3e21c2bcedee9cb089e.png";